"use strict";

exports.__esModule = true;
exports.default = uniq;
var _isBoolean = _interopRequireDefault(require("./isBoolean.js"));
var _cb = _interopRequireDefault(require("./_cb.js"));
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _contains = _interopRequireDefault(require("./contains.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!(0, _isBoolean.default)(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = (0, _cb.default)(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = (0, _getLength.default)(array); i < length; i++) {
    var value = array[i],
      computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!(0, _contains.default)(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!(0, _contains.default)(result, value)) {
      result.push(value);
    }
  }
  return result;
}